"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MbOtpLogin = exports.MbOtp = exports.MbOtpBase = void 0;
// Repositories
const repository_1 = require("../../../security/authoriser/infra/repositories/repository");
const repository_2 = require("../../../security/authoriser/infra/repositories/verifyOtp/repository");
const repository_3 = require("../../../security/authoriser/infra/repositories/verifyOtpLogin/repository");
const repository_4 = require("../../../security/authoriser/infra/repositories/getOtpChannel/repository");
// Events
const events_1 = require("../../../security/events");
// Types
const types_1 = require("../../../security/authoriser/types");
// Constants
const challenges_constants_1 = require("../constants/challenges.constants");
class MbOtpBase {
    constructor(api, data) {
        this.api = api;
        this.progressId = data.progressId;
        this.data = data;
    }
}
exports.MbOtpBase = MbOtpBase;
class MbOtp extends MbOtpBase {
    constructor() {
        super(...arguments);
        this.doRetry = async () => {
            try {
                const { data, httpStatus } = await (0, repository_1.regenerateOTP)(this.api, this.progressId);
                this.data = { ...this.data, otpId: data.otpId };
                if (httpStatus === challenges_constants_1.OTP_LIMIT_CUSTOM_HTTP_STATUS && data?.errorCode === challenges_constants_1.BUSSINESS_VALIDATION_ERROR) {
                    return types_1.ChallengeRetryStatus.LIMIT_REACHED;
                }
                (0, events_1.publishResentChallengeEvent)({ challenge: types_1.ChallengeType.OTP, success: true });
            }
            catch (error) {
                (0, events_1.publishResentChallengeEvent)({ challenge: types_1.ChallengeType.OTP, success: false });
            }
            return types_1.ChallengeRetryStatus.DEFAULT;
        };
    }
    async init() {
        return this.fetchOtpChannel();
    }
    async fetchOtpChannel() {
        let channel = types_1.OtpChallengeChannel.SMS;
        try {
            channel = await repository_4.getOtpChannelRepository.get(this.api, this.progressId);
        }
        catch (err) {
            if (err.errorCode === challenges_constants_1.NO_TRUSTED_ERROR) {
                channel = types_1.OtpChallengeChannel.PUSH;
            }
        }
        this.data = { ...this.data, channel };
    }
    async doVerify(value) {
        const verificationData = {
            id: this.data.otpId,
            value,
        };
        return repository_2.verifyOtpChallengeRepository.verify(this.api, this.progressId, verificationData);
    }
}
exports.MbOtp = MbOtp;
class MbOtpLogin extends MbOtpBase {
    constructor() {
        super(...arguments);
        this.doRetry = async () => {
            try {
                const { data } = await (0, repository_1.resendOTPLogin)(this.api, this.progressId);
                this.data = { ...this.data, otpId: data.otpId };
                (0, events_1.publishResentChallengeEvent)({ challenge: types_1.ChallengeType.OTP_LOGIN, success: true });
            }
            catch (_) {
                (0, events_1.publishResentChallengeEvent)({ challenge: types_1.ChallengeType.OTP_LOGIN, success: false });
            }
        };
    }
    async doVerify(value) {
        const verificationData = {
            id: this.data.otpId,
            value,
        };
        return repository_3.verifyOtpLoginChallengeRepository.verify(this.api, this.progressId, verificationData);
    }
}
exports.MbOtpLogin = MbOtpLogin;
//# sourceMappingURL=otp.js.map